import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import RealtimeStatus from '../../components/RealtimeStatus';
import StatCard from '../../components/StatCard';
import { useLocationData } from '../../hooks/useLocationData';
import Copyright from '../../internals/components/Copyright';
import LocationMap from './LocationMap';


export default function LocationGrid({
  locations,
  maps,
  defaultLocation,
  connectionStatus,
  lastUpdate,
  isRealTimeEnabled
}) {
  const [selectedDriver, setSelectedDriver] = React.useState('');
  const [selectedCarrier, setSelectedCarrier] = React.useState('');

  // Usar hook para derivar todos os dados necessários
  const { drivers, carriers, filteredLocations, stats } = useLocationData(
    locations,
    selectedDriver,
    selectedCarrier
  );

  // Detectar se deve seguir um ponto (apenas 1 localização filtrada)
  const shouldFollowPoint = React.useMemo(() => {
    return filteredLocations.length === 1 && (selectedDriver || selectedCarrier);
  }, [filteredLocations.length, selectedDriver, selectedCarrier]);

  // Determinar qual ponto seguir
  const followedPoint = React.useMemo(() => {
    return shouldFollowPoint ? filteredLocations[0] : null;
  }, [shouldFollowPoint, filteredLocations]);

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(3) }}
      >
        {stats.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard {...card} />
          </Grid>
        ))}

        {/* Status de conexão em tempo real */}
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <RealtimeStatus
            isConnected={connectionStatus === 'connected'}
            lastUpdate={lastUpdate}
            connectionStatus={connectionStatus}
            isRealTimeEnabled={isRealTimeEnabled}
          />
        </Grid>
      </Grid>

      {/* Mapa principal - largura total */}
      <LocationMap
        locations={filteredLocations}
        drivers={drivers}
        carriers={carriers}
        selectedDriver={selectedDriver}
        selectedCarrier={selectedCarrier}
        onDriverChange={setSelectedDriver}
        onCarrierChange={setSelectedCarrier}
        maps={maps}
        defaultLocation={defaultLocation}
        height="calc(100vh - 350px)"
        followedPoint={followedPoint}
        shouldFollowPoint={shouldFollowPoint}
      />

      <Copyright sx={{ my: 4 }} />
    </Box>
  );
} 